// extracted by mini-css-extract-plugin
export default {"bar":"Bar__bar___3G9Lk"};